import IResult from "../../models/result/IResult";
import { sendGet, sendPost, sendPut, sendDelete } from "./generic";
import { ORGANIZATION_VARIABLE } from "../../constants/Urls";
import OrganizationVariable from "../../models/organizations/OrganizationVariable";

export const getOrganizationVariablesByOrganizationId = (organizationId: string): Promise<IResult<OrganizationVariable[]>> => {
    return sendGet<OrganizationVariable[]>(`${ORGANIZATION_VARIABLE}/forOrganization/${organizationId}`);
}

export interface OrganizationVariablePageOptions {
    skip?: number;
    take?: number;
    namePrefix?: string;
}

export const getOrganizationVariablesPageByOrganizationId = (
    organizationId: string,
    options: OrganizationVariablePageOptions,
    baseUrl?: string
): Promise<IResult<OrganizationVariable[]>> => {
    const query = [
        typeof options.skip === "number" ? `skip=${options.skip}` : "",
        typeof options.take === "number" ? `take=${options.take}` : "",
        options.namePrefix ? `namePrefix=${encodeURIComponent(options.namePrefix)}` : ""
    ].filter(Boolean).join("&");

    return sendGet<OrganizationVariable[]>(
        `${ORGANIZATION_VARIABLE}/forOrganization/${organizationId}${query ? `?${query}` : ""}`,
        baseUrl
    );
}

export const getOrganizationVariableById = (organizationVariableId: string): Promise<IResult<OrganizationVariable>> => {
    return sendGet<OrganizationVariable>(`${ORGANIZATION_VARIABLE}/${organizationVariableId}`);
}

export const createOrganizationVariable = (model: OrganizationVariable): Promise<IResult<OrganizationVariable>> => {
    return sendPost<OrganizationVariable>(`${ORGANIZATION_VARIABLE}`, model);
}

export const updateOrganizationVariable = (organizationVariableId: string, model: OrganizationVariable): Promise<IResult<OrganizationVariable>> => {
    return sendPut<OrganizationVariable>(`${ORGANIZATION_VARIABLE}/${organizationVariableId}`, model);
}

export const deleteOrganizationVariable = (organizationVariableId: string): Promise<IResult<OrganizationVariable>> => {
    return sendDelete<OrganizationVariable>(`${ORGANIZATION_VARIABLE}/${organizationVariableId}`);
}
